/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const physicalSecurityEnumsSubCategoryEnum = {
    PhysicalSecurityBreach: 'PhysicalSecurityBreach',
    UnauthorizedAccess: 'UnauthorizedAccess',
    UnauthorizedFilmingPhotography: 'UnauthorizedFilmingPhotography',
    PhysicalSecuritySystem: 'PhysicalSecuritySystem',
    TheftAndPropertyLoss: 'TheftAndPropertyLoss',
    UnescortedVisitorContractor: 'UnescortedVisitorContractor',
    PhysicalAttack: 'PhysicalAttack',
    WorkplaceViolenceAndAggressiveBehavior: 'WorkplaceViolenceAndAggressiveBehavior',
    VandalismAndPropertyDamage: 'VandalismAndPropertyDamage',
    SecurityThreat: 'SecurityThreat',
    NaturalDisaster: 'NaturalDisaster',
    Political: 'Political',
    Other: 'Other',
} as const;

export type PhysicalSecurityEnumsSubCategoryEnumKey =
    (typeof physicalSecurityEnumsSubCategoryEnum)[keyof typeof physicalSecurityEnumsSubCategoryEnum];

export type PhysicalSecurityEnumsSubCategory = PhysicalSecurityEnumsSubCategoryEnumKey;
